export class SelectableAddressField {
   id: number | string = 0;
   value: string = '';
   isExternal: boolean;
}

export interface ISelectableAddressField {
   id: number | string;
   value: string;
   zipCodes: string[];
}
